/**
 * Normalizes an email for storage and comparison.
 *
 * All user emails are stored lowercased (and trimmed). Every write must pass
 * through this helper and every lookup must normalize its query value, so
 * case mismatches (e.g. Stripe webhook payloads, user input) never cause a
 * lookup to miss.
 */
export const normalizeEmail = (email: string): string => email.trim().toLowerCase();
